import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import Tabs from '@ui/tabs/tabs';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppSelector } from '@/store/hooks';
import { selectWorkingProjectDefaultLanguage } from '@/store/slices/project/selectors';
import { useEffect } from 'react';
import Button from '@ui/buttons/button/button';
import { SETTINGS_TABS } from './settings-tab-config';

const Settings = () => {
  const params = useParams();
  const activeTab = params['*'];
  const { projectUuid } = params;

  const navigate = useNavigate();

  const defaultLanguage = useAppSelector(selectWorkingProjectDefaultLanguage);
  const language = defaultLanguage || 'en';

  useEffect(() => {
    if (!activeTab && projectUuid) {
      navigate(`/project/edit/${projectUuid}/${language}/settings/site`);
    }
  }, [activeTab, language, navigate, projectUuid]);

  return (
    <div className="flex-column">
      <Container className="flex-column gap-20" padding="0 var(--main-content-horizontal-padding)">
        <Text tag="h4" className="H4" color="var(--gray-100)">
          Project settings
        </Text>
        <Tabs
          containerClassName="gap-24"
          tabs={SETTINGS_TABS}
          trackUrlParam={{
            type: 'param',
            key: '*',
            pathPattern: `/project/edit/${projectUuid}/${language}/settings/*`,
          }}
          bottomBorder="1px solid var(--gray-700)"
          renderTabItem={(tab, index, { activeIndex, handleTabClick }) => {
            return (
              <Button padding="0px" onClick={() => handleTabClick?.(tab, index)} focusBackgroundColor="var(--gray-700)">
                <Text tag="h5" className="H5" color={activeIndex === index ? 'var(--gray-100)' : 'var(--gray-500)'}>
                  {tab.label}
                </Text>
              </Button>
            );
          }}
        />
      </Container>
    </div>
  );
};

export default Settings;
